const getGooglePlayURLFromAppID = (appID) =>
  `https://play.google.com/store/apps/details?id=${appID}`;

const getAppStoreURLFromAppID = (appID) => `https://itunes.apple.com/app/appName/id${appID}?mt=8`;

const getWordLangKey = (key) => {
  if (["pt-PT", "pt-BR", "zh-CN"].includes(key)) {
    return key;
  }

  // en-US => en, tr-TR => tr
  return key.split("-")[0];
};

const addSlash = (path) => {
  let _path = path;

  if (!path.startsWith("/")) {
    _path = `/${path}`;
  }

  if (!path.endsWith("/")) {
    _path = `${path}/`;
  }

  return _path;
};

module.exports = {
  getGooglePlayURLFromAppID,
  getAppStoreURLFromAppID,
  getWordLangKey,
  addSlash,
};
